import { makeStyles, tokens } from '@fluentui/react-components';

export interface BarLineChartPoint {
  label: string;
  /** 0-100, altura de la barra de fondo */
  barHeightPct: number;
}

interface Props {
  data: BarLineChartPoint[];
  barColor?: string;
  lineColor?: string;
  height?: number;
}

const useStyles = makeStyles({
  wrap: { position: 'relative' },
  barsRow: { position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', gap: '16px', padding: '0 4px' },
  bar: { width: '100%', borderRadius: '6px 6px 0 0', flex: 1 },
  labelsRow: { display: 'flex', justifyContent: 'space-around', fontSize: '11px', color: tokens.colorNeutralForeground3, marginTop: '6px' },
});

/** viewBox fijo 0-300x0-150; la línea se dibuja proporcional a barHeightPct de cada punto. */
function toPolyline(data: BarLineChartPoint[]) {
  if (data.length < 2) return { points: '', dots: [] as { x: number; y: number }[] };
  const stepX = 300 / (data.length - 1);
  const dots = data.map((d, i) => ({ x: i * stepX, y: 150 - (d.barHeightPct / 100) * 140 - 5 }));
  return { points: dots.map(p => `${p.x},${p.y}`).join(' '), dots };
}

/** Combinación de barras de fondo + línea SVG superpuesta — ej. tendencia semanal. */
export function BarLineChart({ data, barColor = tokens.colorBrandBackground2, lineColor = tokens.colorPaletteBlueForeground2, height = 150 }: Props) {
  const s = useStyles();
  const { points, dots } = toPolyline(data);

  return (
    <div>
      <div className={s.wrap} style={{ height }}>
        <div className={s.barsRow}>
          {data.map(d => (
            <div key={d.label} className={s.bar} style={{ height: `${d.barHeightPct}%`, background: barColor }} />
          ))}
        </div>
        <svg viewBox="0 0 300 150" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} preserveAspectRatio="none">
          <polyline points={points} fill="none" stroke={lineColor} strokeWidth={3} />
          {dots.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r={4} fill={lineColor} />)}
        </svg>
      </div>
      <div className={s.labelsRow}>
        {data.map(d => <span key={d.label}>{d.label}</span>)}
      </div>
    </div>
  );
}
